import * as Yup from "yup";

// Login Validation
export const quoteValidationSchema = Yup.object().shape({
	quote: Yup.string().required("Please enter quote"),
	author: Yup.string().required("Please enter author"),
});
